import { Box, Link } from '@opendoor/bricks-next';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentImageAssetLink, IImageAsset } from '../../declarations/contentful';
import ImageAsset from './ImageAsset';

const getSafeHref = (uri?: string) => {
  if (!uri) {
    return null;
  }
  try {
    const url = new URL(uri);
    return url.protocol === 'http:' || url.protocol === 'https:' ? uri : null;
  } catch {
    return null;
  }
};

const renderImageLink = (entry: IComponentImageAssetLink) => {
  const href = getSafeHref(entry?.fields?.uri);
  const image = ImageAsset.render(entry.fields.image as IImageAsset);

  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      {href ? (
        <Link
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          analyticsName="cosmos-articles-image"
        >
          {image}
        </Link>
      ) : (
        image
      )}
    </Box>
  );
};

const ImageAssetLink: EntryComponent<IComponentImageAssetLink> = {
  render: renderImageLink,
};

export default ImageAssetLink;
